const templateUrl = require('./../views/partials/navbar.html');
function navbarDirective($state) {
  "ngInject";
  return {
    templateUrl,
    restrict: 'E',
    link: function(scope, el, attrs) {
      scope.$state = $state;
      scope.currentState = $state.$current.name;
      scope.private_browsing_error = false;
      
      // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
      // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
      // to avoid the entire page breaking, without having to do a check at each usage of Storage.
      if (typeof localStorage === 'object') {
        try {
          localStorage.setItem('localStorage', 1);
          localStorage.removeItem('localStorage');
        } catch (e) {
          scope.private_browsing_error = true;
        }
      }

      el.find('a.mobile').on('click', function(e) {
        e.preventDefault();
        el.find('.links').toggleClass('open')
      })
    }
  };
}

export default navbarDirective;



// WEBPACK FOOTER //
// ./js/containers/users/directives/navbar.js